/** @jsx jsx */
import { jsx } from '@emotion/react';
import { AfterPage, AfterPageProps } from '@sprinx/after-razzle';
import articleData from 'api/articleData';
import Breadcrumbs from 'components/Breadcrumbs';
import Container from 'components/Container';
import Page from 'components/Page';
import MainLayout from 'layouts/MainLayout';
import ErrorPage from 'pages/ErrorPage';
import NotFoundPage from 'pages/NotFoundPage/NotFoundPage';
import LocalizationProvider from 'providers/LocalizationProvider';
import HtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { routeUrl } from 'routesBuilder';
import { Article } from 'types/Article';
import { SupportedLocale, SupportedRegion } from 'types/Supported';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GdprPagePageProps extends AfterPageProps<GdprPageRouteParams> {
  data?: Article;
  locale: SupportedLocale;
  region: SupportedRegion;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GdprPageRouteParams {
  locale: SupportedLocale;
  region: SupportedRegion;
}

const GdprPage: AfterPage<GdprPageRouteParams, GdprPagePageProps> = ({ data, error, locale, region }) => {
  if (error) return <ErrorPage locale={locale} region={region} error={error} />;
  if (!data) return <NotFoundPage locale={locale} region={region} />;

  const { layout, text, title } = data;

  return (
    <LocalizationProvider locale={locale} region={region}>
      <MainLayout locale={locale} {...layout}>
        <Page
          breadcrumbs={
            <Breadcrumbs>
              <Link to={routeUrl('home', { locale, params: { locale: locale, region: region } })}>AppOn.cloud</Link>
              <Link to={routeUrl('gdpr', { locale, params: { locale: locale, region: region } })} className='active'>
                {title}
              </Link>
            </Breadcrumbs>
          }
          pageTitle={title}
          css={{ width: '100%' }}
        >
          <Container maxWidth='lg'>
            <div css={{ '& ol': { margin: '10px 20px', paddingLeft: '20px' }, padding: '40px 0' }}>
              <h1>{title}</h1>
              <div>{HtmlParser(text)}</div>
            </div>
          </Container>
        </Page>
      </MainLayout>
    </LocalizationProvider>
  );
};

GdprPage.getInitialProps = async ({ match }) => {
  const { locale, region } = match.params;

  const data = await articleData.get({ id: 'gdpr', locale, region });

  return {
    data,
    locale,
    region,
  };
};

export default GdprPage;
